<template lang="pug">
div
  v-row.no-gutters.align-center.wrap.justify-end
    v-col(cols="12", md="2")
      v-text-field.mr-1(
        v-model="filters.datainicial",
        color="primary",
        label="Data/Hora inicial",
        type="datetime-local",
        hide-details,
        dense,
        outlined
      )
    v-col(cols="12", md="2")
      v-text-field.mr-1(
        v-model="filters.datafinal",
        color="primary",
        label="Data/Hora final",
        type="datetime-local",
        hide-details,
        dense,
        outlined
      )
    v-btn.mx-1(
      :disabled="loading",
      :loading="loading",
      outlined,
      icon,
      color="primary",
      title="Atualizar",
      @click="getLogs"
    )
      v-icon(small) fa-sync
  v-divider
  DataFilter.csapi-log-filter(:items="logs", :filterProps="filterProps")
    template(v-slot:default="{ items }")
      v-data-table.csapi-log-table(
        :headers="headers",
        :items="items",
        :loading="loading",
        :items-per-page="items.length",
        :expanded.sync="expanded",
        item-key="time",
        :single-expand="true",
        show-expand,
        dense,
        fixed-header,
        hide-default-footer
      )
        template(v-slot:item.time="{ item }")
          span.csapi-log-nowrap {{ formatDate(item.time) }}
        template(v-slot:item.metodo="{ item }")
          v-chip(small, label, outlined) {{ item.tipo }}
        template(v-slot:expanded-item="{ headers, item }")
          td(:colspan="headers.length")
            div(class="dv-data") {{ item.data }}
</template>

<script>
import api from "@/api/csapi";
import { ultimaHoraLocal, periodoParaISO } from "@/utils/tempo";

export default {
  name: "InternalLogs",
  props: {
    // true quando a aba está visível
    active: { type: Boolean, default: false }
  },
  watch: {
    active(isActive) {
      if (isActive && !this.loading) {
        Object.assign(this.filters, ultimaHoraLocal());
        this.getLogs();
      }
    }
  },
  data: () => ({
    loading: false,
    expanded: [],
    headers: [
      { text: "Data/Hora", value: "time" },
      { text: "Tipo", value: "type" },
      { text: "Identificador", value: "identifier" },
      { text: "Mensagem", value: "message" },
      { text: "", value: "data-table-expand" }
    ],
    filterProps: {},
    filters: {
      ...ultimaHoraLocal()
    },
    logs: []
  }),
  computed: {
    //
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString();
    },

    mountDataFilters() {
      this.filterProps = {
        includeSearch: true,
        searchText: this.filterProps.searchText || "",
        items: [
          {
            text: "Tipo",
            type: "select",
            values: this.logs
              .map(item => item.type)
              .sort()
              .map(item => ({
                field: "type",
                text: item,
                value: item
              }))
          },
          {
            text: "Identificador",
            type: "select",
            values: this.logs
              .map(item => item.identifier)
              .sort()
              .map(item => ({
                field: "identifier",
                text: item,
                value: item
              }))
          }
        ]
      };
    },

    async getLogs() {
      const { datainicial: inicio, datafinal: fim } = this.filters;
      if (!inicio || !fim) {
        this.$toast.error("Informe a data/hora inicial e final");
        return;
      }
      if (new Date(inicio) > new Date(fim)) {
        this.$toast.error("A data/hora inicial deve ser anterior à final");
        return;
      }

      // Uma busca por vez
      if (this.loading) return;
      this.loading = true;
      try {
        const { datainicial, datafinal } = periodoParaISO(this.filters);

        const query = `?datainicial=${datainicial}&datafinal=${datafinal}`;

        const res = await api.get(`/logs/internos${query}`);
        this.logs = res.data;
        this.mountDataFilters();
      } catch (error) {
        console.error(error);
        this.logs = [];
        this.mountDataFilters();
        this.$toast.error(`Erro ao carregar logs: ${error.message}`);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    // Chips e busca visíveis antes da primeira carga
    this.mountDataFilters();
    this.getLogs();
  }
};
</script>

<style scoped>
.dv-data {
  white-space: pre-wrap;
}
</style>
